import InterfaceFormPrefill from "../apiInterface/InterfaceFormPrefill";

export interface FieldProvenance {
  source_type: string;
  source_label: string;
  source_register_id: number | null;
  source_record_id: number | null;
  recorded_at: string | null;
  recorded_by_name: string | null;
}

export interface PrefillPayload {
  form_key: string;
  pasien_rm: string;
  register_id: number | null;
  sources: string[];
  fields: Record<string, any>;
  provenance: Record<string, FieldProvenance>;
}

/**
 * Read-side: fetch the prefill payload for a given form. Returns null on
 * error to keep the form usable even if autofill is unavailable.
 */
async function fetchPrefill(
  pasienRm: string,
  formKey: string,
  params: {
    register_id?: number | string;
    unit_id?: string;
    sources?: string[];
  } = {}
): Promise<PrefillPayload | null> {
  try {
    const res = await InterfaceFormPrefill.getPrefill(pasienRm, formKey, {
      register_id: params.register_id,
      unit_id: params.unit_id,
      sources: params.sources ? params.sources.join(",") : undefined
    });
    if (!res || !res.data || res.data.status !== "1") {
      return null;
    }
    return res.data.data as PrefillPayload;
  } catch (e) {
    // Autofill is best-effort: never block the form.
    // eslint-disable-next-line no-console
    console.warn("[FormPrefill] fetch failed", e);
    return null;
  }
}

/**
 * Audit log: tell the backend which prefilled fields the user kept vs.
 * cleared. Fire-and-forget; failures should not surface to the UI.
 */
function logAcceptance(payload: {
  form_key: string;
  pasien_rm: string;
  register_id?: number | string | null;
  unit_id?: string | null;
  event: "accepted" | "rejected" | "partial";
  fields: string[];
  provenance?: Record<string, FieldProvenance>;
  sources?: string[];
}) {
  return InterfaceFormPrefill.logAcceptance(payload).catch(e => {
    // eslint-disable-next-line no-console
    console.warn("[FormPrefill] log failed", e);
  });
}

export default { fetchPrefill, logAcceptance };
